module.exports = __webpack_public_path__ + "static/media/TurkeyStrut.svg";